import React, { useState } from "react";
import { Box, Tabs as MuiTabs, Tab as MuiTab, useTheme, useMediaQuery } from "@material-ui/core";
import { getBoxMarginProps, getBreakpointValue } from "./functions";
import { useEditor, useNode } from "@craftjs/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
	tabs: {
		gap: '8px',
		'& .MuiTabs-flexContainer': {
			justifyContent: 'center',
			gap: '8px'
		},
		'& .MuiTabs-indicator': {
			display: 'none',
		},
	},
	tab: {
		opacity: '1',
		color: '#FFFFFF',
		backgroundColor: 'transparent',
		border: '2px solid #FFFFFF',
		fontFamily: 'Manrope',
		fontWeight: '700',
		'&.Mui-selected': {
			color: '#000000',
			backgroundColor: '#FFFFFF',
		}
	}
});

export const Tabs = (props) => {
	const theme = useTheme();
	const classes = useStyles();
	const breakpoint = useMediaQuery(theme.breakpoints.only('xs')) ? 'xs' : 'md';

	const { query, actions } = useEditor();

	const { childNodes } = useNode(node => ({
        childNodes: node.data.nodes.map(nodeId => query.node(nodeId).get()),
    }));

	function handleChange(event, value) {
		setCurrentTab(value)
	}

	const children = props.children?.props?.children || [];

	const sortedTabs = childNodes.sort((childA, childB) => {
        const valA = getBreakpointValue(childA.data.props, breakpoint, 'order');
        const valB = getBreakpointValue(childB.data.props, breakpoint, 'order');
      
        const orderA = valA === '' ? Infinity : Number(valA);
        const orderB = valB === '' ? Infinity : Number(valB);
      
        return orderA - orderB;
    });

    const [currentTab, setCurrentTab] = useState(sortedTabs[0].id);

	return (
		<Box
			{...getBoxMarginProps(props, breakpoint, false)}
		>
			<MuiTabs value={currentTab} onChange={handleChange} className={classes.tabs}>
				{sortedTabs.map(tab => {
                    const label =  tab?.data?.props?.title || 'Tab';
                    return (
                        <MuiTab 
							label={label} 
							value={tab.id} 
							onClick={() => actions.selectNode(tab.id)} 
							className={classes.tab}
						/>
                    )
                })}
			</MuiTabs>
			<Box paddingTop="64px">
				{children.map(tab => (
					<Box hidden={tab.props.id !== currentTab}>
						{tab}
					</Box>
				))}
			</Box>
		</Box>
	);
}

export const Tab = (props) => {
	return (
		<Box>
            {props.children}
		</Box>
	);
}
